import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-452163f2")

_pushScopeId("data-v-452163f2")
const _hoisted_1 = {
  key: 0,
  class: "back-button"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")

  return (!_ctx.isIcon)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Button, { onClick: _ctx.back }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t("back")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]))
    : (_openBlock(), _createBlock(_component_Button, {
        key: 1,
        icon: "pi pi-arrow-left",
        class: "p-button-rounded p-button-outlined p-button-secondary",
        onClick: _ctx.back
      }, null, 8, ["onClick"]))
})